import Alpine from 'alpinejs';

Alpine.data('schoolCollectionLink', () => ({
  init() {
    if (!window.Cookies) {
      return;
    }

    const Cookies = window.Cookies;
    const collection_url = Cookies.get('collection_url');

    if (collection_url) {
      this.$el.setAttribute('href', collection_url);
      this.$el.querySelector('span').textContent = "Back to 'Select subjects'";
    }
  },
}));
